// LAZY loaded component
import useFrontendBoot from "@/Hooks/useFrontendBoot";
import useRoutesHandler from "@/Hooks/useRouteHandler";
import useLogin from "@/Pages/Login/hooks/useLogin";
import { SIDE_TABS } from "@/Routes/sidebar.utility";
import { stringUtility } from "@repo/utilities/string.utility.ts";
import useJourneyRequests from "customer/journeyRequestHandler";
import { Suspense } from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../Navbar";
import Sidebar from "../Sidebar";
import AllPages from "./components/AllPages";
import SuspenseFallback from "./components/SuspenseFallback";
import InactivityWrapper from "../InactivityModal/InactivityWrapper";
import FullPageLoader from "@/UI/Loaders/FullPageLoader";

export default function SuspenseRouteHandler({ route }: { route: string }) {
  const { frontendBootService } = useFrontendBoot();
  const generalSettingsData =
    frontendBootService?.data?.data?.settings?.general;
  // // CUSTOM-HOOKS

  const { route: urlRoutes } = useRoutesHandler();
  // ASSISTED JOURNEY-HOOKS
  useJourneyRequests();
  const isIPPB =
    frontendBootService?.data?.data?.settings?.general?.name ===
    "India Post Payment Bank";
  const FILTER_SIDE_TABS = isIPPB
    ? SIDE_TABS
    : SIDE_TABS?.map((sideTabs) => {
      if (sideTabs?.code !== "report-management") return sideTabs;
      const updateSubTab = sideTabs?.subTabs?.filter(
        (subTabs) => subTabs?.code !== "loader-file"
      );
      return {
        ...sideTabs,
        subTabs: updateSubTab,
      };
    });

  const {
    functions: { handleLogout },
  } = useLogin();
  if (frontendBootService?.isPending) return <FullPageLoader />;

  return (
    <div className="h-screen w-full flex bg-primary/10">
      {generalSettingsData && (
        <Helmet>
          <link
            rel="icon"
            type="image/svg+xml"
            href={generalSettingsData?.favicon?.original_url}
          />
          <title>{generalSettingsData?.meta_title}</title>
          <meta
            name="description"
            content={generalSettingsData?.meta_description}
          />
        </Helmet>
      )}
      <Sidebar logoutHandler={handleLogout} TABS={FILTER_SIDE_TABS} />

      <main className="flex-1 relative flex flex-col w-full h-full bg-white min-[450px]:rounded-l-3xl shadow-xl overflow-y-auto">
        <Navbar TABS={FILTER_SIDE_TABS} />
        <Suspense fallback={<SuspenseFallback />}>
          {urlRoutes.subTab ? (
            <AllPages
              route={stringUtility.removeCharAddSpace(urlRoutes.subTab, "-")}
            />
          ) : (
            <AllPages route={route} />
          )}
        </Suspense>
        <InactivityWrapper />
      </main>
    </div>
  );
}
